import ReelsetController from "../../../Elements/Reel/ReelsetController";

class FreeSpinReelSetController extends ReelsetController {}

export default FreeSpinReelSetController;
